import React, { createContext } from 'react';

import { permissionScoreData } from '../const';
import {
    CalcScorePermissionType,
    PermissionCombinationType,
    PermissionListActionType,
    PermissionListGroupType,
    PermissionListType,
    PermissionListTypeType,
} from '../types';

export interface IPermissionContext {
    permissionListScore: Set<number>;
    userId: string;
    displayName: string;
}

export const SmxPermissionContext = createContext<IPermissionContext>({
    permissionListScore: new Set(),
    userId: '',
    displayName: 'Guest',
});

export const calcScorePermission = (
    permission: PermissionCombinationType | PermissionListType,
): CalcScorePermissionType => {
    const partListPermission = permission.split('.');

    let scoreGroup = 0,
        scoreType = 0,
        scoreAction = 0;

    partListPermission.forEach((part) => {
        scoreGroup += permissionScoreData.group[part as PermissionListGroupType] || 0;
        scoreType += permissionScoreData.type[part as PermissionListTypeType] || 0;
        scoreAction += permissionScoreData.action[part as PermissionListActionType] || 0;
    });

    return { scoreGroup, scoreType, scoreAction, totalScore: scoreGroup + scoreType + scoreAction };
};

interface IPermissionProvider {
    children: React.ReactNode;
    permissionList: PermissionListType[];
    userId: string;
    displayName: string;
}

export const PermissionProvider: React.FC<IPermissionProvider> = ({
    permissionList,
    userId,
    children,
    displayName,
}) => {
    const permissionListScore = new Set<number>();

    permissionList.forEach((permission) => {
        const partPermission = permission.split('.');
        let newPermission = permission;
        if (partPermission.length === 2) {
            newPermission = `${partPermission[0]}.all.${partPermission[1]}` as PermissionListType;
        }
        const { scoreGroup, scoreType, scoreAction, totalScore } = calcScorePermission(newPermission);

        if (totalScore) permissionListScore.add(totalScore);
        if (scoreGroup + scoreType) permissionListScore.add(scoreGroup + scoreType);
        if (scoreGroup + scoreAction) permissionListScore.add(scoreGroup + scoreAction);
        if (scoreType + scoreAction) permissionListScore.add(scoreType + scoreAction);
        if (scoreType) permissionListScore.add(scoreType);
        if (scoreAction) permissionListScore.add(scoreAction);
        if (scoreGroup) permissionListScore.add(scoreGroup);
    });

    return (
        <SmxPermissionContext.Provider
            value={{
                permissionListScore,
                userId,
                displayName,
            }}
        >
            {children}
        </SmxPermissionContext.Provider>
    );
};
